import { ReactComponent as SquadsSidebarSvg } from "../../assets/images/svgs/squadsSidebar.svg";

const SquadsSidebarIcon = ({ className = "", ...props }) => {
  return (
    <SquadsSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default SquadsSidebarIcon;
